module.exports = __webpack_public_path__ + "static/img/home-pub-df.bc7d4ca5.jpg";